import { render, staticRenderFns } from "./course-progress.vue?vue&type=template&id=5ac204aa&scoped=true"
import script from "./course-progress.vue?vue&type=script&lang=js"
export * from "./course-progress.vue?vue&type=script&lang=js"
import style0 from "./course-progress.vue?vue&type=style&index=0&id=5ac204aa&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ac204aa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_manage_sbGx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5ac204aa')) {
      api.createRecord('5ac204aa', component.options)
    } else {
      api.reload('5ac204aa', component.options)
    }
    module.hot.accept("./course-progress.vue?vue&type=template&id=5ac204aa&scoped=true", function () {
      api.rerender('5ac204aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/senate/detail-pane/course-progress.vue"
export default component.exports